module.exports = __webpack_public_path__ + "static/og-image-1de875f0b85f446524a53f828b050665.jpg";